import { CommonHelper } from "../helpers";
import { EntityTypes } from "../helpers/constant";
export default {
  setSuperProjections(payload, userInput, entityType, clientId) {
    let p = {};
    p.superProjectionResult = [];
    p.incomeExpense = [];

    const payloadData = CommonHelper.groupBy(
      "referenceGuid",
      payload.superAccumulationResult
    );
    if (!payload.superPensionResult) {
      payload.superPensionResult = [];
    }

    for (let i = 0; i < payloadData.length; i++) {
      // accumuation
      //pension
      let superProjectionInfo = this.createSuperProjectionInfoModel();
      let totalProjectionYear = payloadData[i][0].superProjection.length;
      superProjectionInfo.description = this.getSuperFundName(
        userInput,
        payloadData[i][0].referenceGuid
      );
      superProjectionInfo.totalCurrentBalance = this.getTotalBalance(
        userInput,
        payloadData[i][0].referenceGuid,
        entityType == EntityTypes.both ? 0 : clientId
      );
      superProjectionInfo.uniqueId = payloadData[i][0].referenceGuid;
      superProjectionInfo.RetirementBalance = this.getTotalRetireBalance(
        payloadData[i],
        entityType
      );

      superProjectionInfo.BalanceRunOutAt = this.getBalanceRunOutAt(
        payloadData[i],
        entityType
      );

      let pensionPayload = payload.superPensionResult.filter(
        (sr) => sr.referenceGuid == payloadData[i][0].referenceGuid
      );
      superProjectionInfo.RetirementBalance =
        superProjectionInfo.RetirementBalance +
        this.getTotalRetireBalance(pensionPayload, entityType);
      for (let k = 0; k < totalProjectionYear; k++) {
        let superProjection = this.createSuperProjectionModel();
        // accumulation
        for (let j = 0; j < payloadData[i].length; j++) {
          if (
            payloadData[i][j].entityType ==
            (entityType == EntityTypes.client ||
            entityType == EntityTypes.partner
              ? entityType
              : payloadData[i][j].entityType)
          ) {
            superProjection.year = payloadData[i][j].superProjection[k].year;
            superProjection.openingBalance =
              superProjection.openingBalance +
              payloadData[i][j].superProjection[k].openingBalance;

            superProjection.withdrawalsSOM =
              superProjection.withdrawalsSOM +
              payloadData[i][j].superProjection[k].withdrawalsSOM;

            superProjection.recontributionStrategy =
              superProjection.recontributionStrategy +
              payloadData[i][j].superProjection[k].recontributionStrategy;
            superProjection.dividendReinvested =
              superProjection.dividendReinvested +
              payloadData[i][j].superProjection[k].dividendReinvested;
            superProjection.contsConcessionalEOM =
              superProjection.contsConcessionalEOM +
              payloadData[i][j].superProjection[k].contsConcessionalEOM;
            superProjection.contsConcessionalEOM1 =
              superProjection.contsConcessionalEOM1 +
              payloadData[i][j].superProjection[k].contsConcessionalEOM1;
            superProjection.contsEmployerEOM =
              superProjection.contsEmployerEOM +
              payloadData[i][j].superProjection[k].contsEmployerEOM;
            superProjection.contsTotalNetEOM =
              superProjection.contsTotalNetEOM +
              payloadData[i][j].superProjection[k].contsTotalNetEOM;
            superProjection.contsSalarySacrificeEOM =
              superProjection.contsSalarySacrificeEOM +
              payloadData[i][j].superProjection[k].contsSalarySacrificeEOM;
            superProjection.contsTaxOnCCEOM =
              superProjection.contsTaxOnCCEOM +
              payloadData[i][j].superProjection[k].contsTaxOnCCEOM;

            superProjection.contsTotalNonConcessionalEOM =
              superProjection.contsTotalNonConcessionalEOM +
              payloadData[i][j].superProjection[k].contsTotalNonConcessionalEOM;
            superProjection.contsNonConcessionalEOM =
              superProjection.contsNonConcessionalEOM +
              payloadData[i][j].superProjection[k].contsNonConcessionalEOM;

            superProjection.contsSpouseEOM =
              superProjection.contsSpouseEOM +
              payloadData[i][j].superProjection[k].contsSpouseEOM;

            superProjection.withdrawalsEOM =
              superProjection.withdrawalsEOM +
              payloadData[i][j].superProjection[k].withdrawalsEOM;

            superProjection.insurancePremium =
              superProjection.insurancePremium +
              payloadData[i][j].superProjection[k].insurancePremium;

            superProjection.expenses =
              superProjection.expenses +
              payloadData[i][j].superProjection[k].expenses;

            superProjection.insurancePremium =
              superProjection.insurancePremium +
              payloadData[i][j].superProjection[k].insurancePremium;

            superProjection.taxation =
              superProjection.taxation +
              payloadData[i][j].superProjection[k].taxation;
            superProjection.taxationTotalAssessableIncome =
              superProjection.taxationTotalAssessableIncome +
              payloadData[i][j].superProjection[k]
                .taxationTotalAssessableIncome;
            superProjection.taxationTotalConcessionalConts =
              superProjection.taxationTotalConcessionalConts +
              payloadData[i][j].superProjection[k]
                .taxationTotalConcessionalConts;
            superProjection.taxationIncome =
              superProjection.taxationIncome +
              payloadData[i][j].superProjection[k].taxationIncome;
            superProjection.taxationFrankingCredits =
              superProjection.taxationFrankingCredits +
              payloadData[i][j].superProjection[k].taxationFrankingCredits;
            superProjection.taxationExpenses =
              superProjection.taxationExpenses +
              payloadData[i][j].superProjection[k].taxationExpenses;
            superProjection.taxationTotalTaxPayable =
              superProjection.taxationTotalTaxPayable +
              payloadData[i][j].superProjection[k].taxationTotalTaxPayable;
            superProjection.taxationPayableOnAssessableIncome =
              superProjection.taxationPayableOnAssessableIncome +
              payloadData[i][j].superProjection[k]
                .taxationPayableOnAssessableIncome;
            superProjection.taxationDiv293Payable =
              superProjection.taxationDiv293Payable +
              payloadData[i][j].superProjection[k].taxationDiv293Payable;
            superProjection.taxationContributionsTaxPayable =
              superProjection.taxationContributionsTaxPayable +
              payloadData[i][j].superProjection[k]
                .taxationContributionsTaxPayable;
            superProjection.taxationFrankingCreditsAsCredit =
              superProjection.taxationFrankingCreditsAsCredit +
              payloadData[i][j].superProjection[k]
                .taxationFrankingCreditsAsCredit;

            superProjection.contributionsEOMAuto =
              superProjection.contributionsEOMAuto +
              payloadData[i][j].superProjection[k].contributionsEOMAuto;
            superProjection.withdrawalsEOMAuto =
              superProjection.withdrawalsEOMAuto +
              payloadData[i][j].superProjection[k].withdrawalsEOMAuto;

            superProjection.employer =
              superProjection.employer +
              payloadData[i][j].superProjection[k].contsEmployerEOM;

            superProjection.salarySacrifice =
              superProjection.salarySacrifice +
              payloadData[i][j].superProjection[k].contsSalarySacrificeEOM;

            superProjection.contributionsTax =
              superProjection.contributionsTax +
              payloadData[i][j].superProjection[k].contsTaxOnCCEOM;

            superProjection.nonContributionContribution =
              superProjection.nonContributionContribution +
              payloadData[i][j].superProjection[k].contsNonConcessionalEOM +
              payloadData[i][j].superProjection[k].contributionsEOMAuto;

            superProjection.incomeReturn =
              superProjection.incomeReturn +
              payloadData[i][j].superProjection[k].incomeReturn;
            superProjection.growthReturn =
              superProjection.growthReturn +
              payloadData[i][j].superProjection[k].growthReturn;
            superProjection.frankingCredit =
              superProjection.frankingCredit +
              payloadData[i][j].superProjection[k].frankingCredit;
            superProjection.incomeReturnCumulative =
              superProjection.incomeReturnCumulative +
              payloadData[i][j].superProjection[k].incomeReturnCumulative;
            superProjection.growthReturnCumulative =
              superProjection.growthReturnCumulative +
              payloadData[i][j].superProjection[k].growthReturnCumulative;

            superProjection.incomeGrowthReturnCumulative =
              superProjection.incomeGrowthReturnCumulative +
              payloadData[i][j].superProjection[k].incomeReturnCumulative +
              payloadData[i][j].superProjection[k].growthReturnCumulative;

            superProjection.contributionsAll =
              superProjection.contributionsAll +
              payloadData[i][j].superProjection[k].contributionsAll;

            superProjection.contributionsAllCumulative =
              superProjection.contributionsAllCumulative +
              payloadData[i][j].superProjection[k].contributionsAllCumulative;

            superProjection.withdrawalsAll =
              superProjection.withdrawalsAll +
              payloadData[i][j].superProjection[k].withdrawalsAll;
            superProjection.pensionPayments =
              0 + superProjection.pensionPayments;

            superProjection.withdrawalsAllCumulative =
              superProjection.withdrawalsAllCumulative +
              payloadData[i][j].superProjection[k].withdrawalsAllCumulative;
            superProjection.closingBalance =
              superProjection.closingBalance +
              payloadData[i][j].superProjection[k].closingBalance;

            superProjection.adviceFees =
              superProjection.adviceFees +
              payloadData[i][j].superProjection[k].adviceFees;
            superProjection.platformFees =
              superProjection.platformFees +
              payloadData[i][j].superProjection[k].platformFees;
            superProjection.otherFees =
              superProjection.otherFees +
              payloadData[i][j].superProjection[k].otherFees;
            superProjection.incomeGrowthNetFees =
              superProjection.incomeGrowthNetFees +
              payloadData[i][j].superProjection[k].incomeReturn +
              payloadData[i][j].superProjection[k].growthReturn +
              payloadData[i][j].superProjection[k].platformFees +
              payloadData[i][j].superProjection[k].adviceFees +
              payloadData[i][j].superProjection[k].otherFees;

            superProjection.incomeGrowthFees =
              superProjection.incomeGrowthFees +
              payloadData[i][j].superProjection[k].incomeReturn +
              payloadData[i][j].superProjection[k].growthReturn;
            superProjection.fees =
              superProjection.fees +
              payloadData[i][j].superProjection[k].platformFees +
              payloadData[i][j].superProjection[k].adviceFees +
              payloadData[i][j].superProjection[k].otherFees;
          }
        }
        // pension
        if (pensionPayload.length > 0) {
          for (let j = 0; j < pensionPayload.length; j++) {
            if (
              pensionPayload[j].entityType ==
              (entityType == EntityTypes.client ||
              entityType == EntityTypes.partner
                ? entityType
                : pensionPayload[j].entityType)
            ) {
              superProjection.year = pensionPayload[j].superProjection[k].year;
              superProjection.openingBalance =
                superProjection.openingBalance +
                pensionPayload[j].superProjection[k].openingBalance;

              superProjection.recontributionStrategy =
                superProjection.recontributionStrategy +
                pensionPayload[j].superProjection[k].recontributionStrategy;

              superProjection.withdrawalsEOMAuto =
                superProjection.withdrawalsEOMAuto +
                pensionPayload[j].superProjection[k].withdrawalsEOMAuto;

              superProjection.dividendReinvested =
                superProjection.dividendReinvested +
                pensionPayload[j].superProjection[k].dividendReinvested;

              superProjection.withdrawalsSOM =
                superProjection.withdrawalsSOM +
                pensionPayload[j].superProjection[k].withdrawalsSOM;

              superProjection.withdrawalsEOM =
                superProjection.withdrawalsEOM +
                pensionPayload[j].superProjection[k].withdrawalsEOM;
              superProjection.expenses =
                superProjection.expenses +
                pensionPayload[j].superProjection[k].expenses;
              superProjection.pensionPayments =
                superProjection.pensionPayments +
                pensionPayload[j].superProjection[k].pensionPayments;

              superProjection.insurancePremium =
                superProjection.insurancePremium +
                pensionPayload[j].superProjection[k].insurancePremium;

              superProjection.incomeReturn =
                superProjection.incomeReturn +
                pensionPayload[j].superProjection[k].incomeReturn;
              superProjection.growthReturn =
                superProjection.growthReturn +
                pensionPayload[j].superProjection[k].growthReturn;

              superProjection.frankingCredit =
                superProjection.frankingCredit +
                pensionPayload[j].superProjection[k].frankingCredit;

              superProjection.incomeReturnCumulative =
                superProjection.incomeReturnCumulative +
                pensionPayload[j].superProjection[k].incomeReturnCumulative;
              superProjection.growthReturnCumulative =
                superProjection.growthReturnCumulative +
                pensionPayload[j].superProjection[k].growthReturnCumulative;
              superProjection.incomeGrowthReturnCumulative =
                superProjection.incomeGrowthReturnCumulative +
                pensionPayload[j].superProjection[k].incomeReturnCumulative +
                pensionPayload[j].superProjection[k].growthReturnCumulative;

              superProjection.withdrawalsAllCumulative =
                superProjection.withdrawalsAllCumulative +
                pensionPayload[j].superProjection[k].withdrawalsAllCumulative;
              superProjection.withdrawalsAll =
                superProjection.withdrawalsAll +
                pensionPayload[j].superProjection[k].withdrawalsAll;
              superProjection.closingBalance =
                superProjection.closingBalance +
                pensionPayload[j].superProjection[k].closingBalance;
              superProjection.adviceFees =
                superProjection.adviceFees +
                pensionPayload[j].superProjection[k].adviceFees;
              superProjection.platformFees =
                superProjection.platformFees +
                pensionPayload[j].superProjection[k].platformFees;
              superProjection.otherFees =
                superProjection.otherFees +
                pensionPayload[j].superProjection[k].otherFees;

              superProjection.incomeGrowthNetFees =
                superProjection.incomeGrowthNetFees +
                pensionPayload[j].superProjection[k].incomeReturn +
                pensionPayload[j].superProjection[k].growthReturn +
                pensionPayload[j].superProjection[k].platformFees +
                pensionPayload[j].superProjection[k].adviceFees +
                pensionPayload[j].superProjection[k].otherFees;

              superProjection.incomeGrowthFees =
                superProjection.incomeGrowthFees +
                pensionPayload[j].superProjection[k].incomeReturn +
                pensionPayload[j].superProjection[k].growthReturn;

              superProjection.fees =
                superProjection.fees +
                pensionPayload[j].superProjection[k].platformFees +
                pensionPayload[j].superProjection[k].adviceFees +
                pensionPayload[j].superProjection[k].otherFees;
            }
          }
        }
        superProjectionInfo.superProjection.push(superProjection);
      }
      p.superProjectionResult.push(superProjectionInfo);
      p.incomeExpense.push(
        this.getIncomeExpenseDataFromPayload(
          payload,
          entityType,
          payloadData[i][0].referenceGuid,
          superProjectionInfo.description
        )
      );
    }
    for (let i = 0; i < p.superProjectionResult.length; i++) {
      for (
        let j = 0;
        j < p.superProjectionResult[i].superProjection.length;
        j++
      ) {
        p.superProjectionResult[i].superProjection[j].graphTitle =
          p.incomeExpense[i].superProjection[j].graphTitle;
      }
    }
    return p;
  },

  getIncomeExpenseDataFromPayload(
    payload,
    entityType,
    referenceGuid,
    description
  ) {
    let incomePayload = payload;
    if (payload && payload.incomeExpenseResult.length > 0) {
      let filterPayloadData = payload.incomeExpenseResult.filter(
        (sr) => sr.referenceGuid == referenceGuid
      );
      if (filterPayloadData && filterPayloadData.length > 0) {
        incomePayload = { incomeExpenseResult: filterPayloadData };
      }
    }
    return this.getIncomeExpenseProjectionResult(
      incomePayload,
      entityType,
      description,
      referenceGuid
    );
  },
  getIncomeExpenseProjectionResult(
    payload,
    entityType,
    description,
    referenceGuid
  ) {
    let incomeExpenseResult = [];
    if (!payload.incomeExpenseResult) {
      return;
    }

    let totalProjectionYear =
      payload.incomeExpenseResult[0].incomeExpenseProjections.length;
    for (let k = 0; k < totalProjectionYear; k++) {
      let incomeExpenseData = this.getIncomeExpenseModel();
      for (let i = 0; i < payload.incomeExpenseResult.length; i++) {
        const incomeData = payload.incomeExpenseResult[i];

        if (
          entityType == EntityTypes.both ||
          entityType == incomeData.entityType
        ) {
          const clientIncomeProjection = incomeData.incomeExpenseProjections[k];
          incomeExpenseData.year = incomeData.incomeExpenseProjections[k].year;
          if (!incomeExpenseData.age) {
            incomeExpenseData.age = incomeData.incomeExpenseProjections[k].age;
          } else {
            incomeExpenseData.age =
              incomeExpenseData.age +
              " / " +
              incomeData.incomeExpenseProjections[k].age;
          }
          incomeExpenseData.totalIncome =
            incomeExpenseData.totalIncome + clientIncomeProjection.totalInflow;
          incomeExpenseData.inflow =
            incomeExpenseData.inflow + clientIncomeProjection.totalInflow;
          incomeExpenseData.totalOutflow =
            incomeExpenseData.totalOutflow +
            (clientIncomeProjection.totalOutflow -
              clientIncomeProjection.paygwIthheldProvision);
          incomeExpenseData.totalExpense =
            incomeExpenseData.totalExpense +
            clientIncomeProjection.totalOutflow +
            clientIncomeProjection.taxation.netTaxRefundPayable;

          incomeExpenseData.expenses =
            incomeExpenseData.expenses + clientIncomeProjection.expenses.total;
          incomeExpenseData.invContribution =
            incomeExpenseData.invContribution +
            clientIncomeProjection.investmentContributions.total;
          incomeExpenseData.superContribution =
            incomeExpenseData.superContribution +
            clientIncomeProjection.superContributions.total;
          incomeExpenseData.taxes =
            incomeExpenseData.taxes +
            clientIncomeProjection.taxation.actualTaxPayable;
          incomeExpenseData.employmentIncome =
            incomeExpenseData.employmentIncome +
            clientIncomeProjection.employmentIncome.total;
          incomeExpenseData.agePension =
            incomeExpenseData.agePension +
            clientIncomeProjection.otherIncome.agePension;
          incomeExpenseData.superPension =
            incomeExpenseData.superPension +
            clientIncomeProjection.otherIncome.pensionPayments;
          incomeExpenseData.otherIncome =
            incomeExpenseData.otherIncome +
            clientIncomeProjection.otherIncome.investment +
            clientIncomeProjection.otherIncome.annuityPayments +
            clientIncomeProjection.otherIncome.other;
          incomeExpenseData.netCashFlow =
            incomeExpenseData.netCashFlow + clientIncomeProjection.netCashflow;
        }
      }
      incomeExpenseData.graphTitle = `Year ${k + 1} | ${
        incomeExpenseData.year
      } | Age ${incomeExpenseData.age}`;
      incomeExpenseResult.push(incomeExpenseData);
    }
    let incomeexpenseobj = {};
    incomeexpenseobj.superProjection = incomeExpenseResult;
    incomeexpenseobj.uniqueId = referenceGuid;
    incomeexpenseobj.description = description;
    return incomeexpenseobj;
  },
  getTotalBalance(funds, refrerenceId, clientId) {
    let amount = 0;
    let selectedFunds = funds.filter((sr) => sr.referenceGuid == refrerenceId);
    if (selectedFunds.length > 0) {
      for (let i = 0; i < selectedFunds[0].superfundDetails.length; i++) {
        if (
          clientId == 0 ||
          selectedFunds[0].superfundDetails[i].clientId == clientId
        ) {
          if (selectedFunds[0].superfundDetails[i].isIncludeContribution) {
            amount =
              amount + selectedFunds[0].superfundDetails[i].superFundBalance;
          }
        }
      }
    }
    return amount;
  },
  getTotalRetireBalance(payload, entityType) {
    let returnValue = 0;
    for (let i = 0; i < payload.length; i++) {
      if (
        payload[i].entityType ==
        (entityType == EntityTypes.client || entityType == EntityTypes.partner
          ? entityType
          : payload[i].entityType)
      ) {
        returnValue = returnValue + payload[i].projectedValueRetirement;
      }
    }
    return returnValue;
  },
  getBalanceRunOutAt(payload, entityType) {
    let returnValue = undefined;
    for (let i = 0; i < payload.length; i++) {
      if (
        payload[i].entityType ==
        (entityType == EntityTypes.client || entityType == EntityTypes.partner
          ? entityType
          : payload[i].entityType)
      ) {
        if (!returnValue) returnValue = payload[i].ageSuperBenefitsRunsOut;
        else
          returnValue =
            returnValue + " / " + payload[i].ageSuperBenefitsRunsOut;
      }
    }
    return returnValue;
  },
  getSuperFundName(funds, refrerenceId) {
    let name = 0;
    let selectedFunds = funds.filter((sr) => sr.referenceGuid == refrerenceId);
    if (selectedFunds.length > 0) {
      name = selectedFunds[0].name;
    }

    return name;
  },

  getIncomeExpenseModel() {
    let obj = {
      totalIncome: 0,
      totalExpense: 0,
      employmentIncome: 0,
      agePension: 0,
      superPension: 0,
      inflow: 0,
      otherIncome: 0,
      outflow: 0,
      invContribution: 0,
      superContribution: 0,
      taxes: 0,
      netCashFlow: 0,
      expenses: 0,
      totalOutflow: 0,
    };
    return obj;
  },

  createSuperProjectionInfoModel() {
    const superProjectionInfo = {
      totalCurrentBalance: 0,

      superProjection: [],
    };
    return superProjectionInfo;
  },
  createSuperProjectionModel() {
    const superProjection = {
      year: 0,
      openingBalance: 0,
      recontributionStrategy: 0,
      withdrawalsSOM: 0,
      incomeReturn: 0,
      growthReturn: 0,
      frankingCredit: 0,
      dividendReinvested: 0,
      contsTotalNetEOM: 0,
      contsConcessionalEOM: 0,
      contsEmployerEOM: 0,
      contsSalarySacrificeEOM: 0,
      contsConcessionalEOM1: 0,
      contsTaxOnCCEOM: 0,
      contsTotalNonConcessionalEOM: 0,
      contsNonConcessionalEOM: 0,
      contsSpouseEOM: 0,
      pensionPayments: 0,
      withdrawalsEOM: 0,
      insurancePremium: 0,
      taxation: 0,
      taxationTotalAssessableIncome: 0,
      taxationTotalConcessionalConts: 0,
      taxationIncome: 0,
      taxationFrankingCredits: 0,
      taxationExpenses: 0,
      taxationTotalTaxPayable: 0,
      taxationPayableOnAssessableIncome: 0,
      taxationDiv293Payable: 0,
      taxationContributionsTaxPayable: 0,
      taxationFrankingCreditsAsCredit: 0,
      contributionsEOMAuto: 0,
      withdrawalsEOMAuto: 0,
      incomeGrowthNetFees: 0,
      incomeReturnCumulative: 0,
      growthReturnCumulative: 0,
      frankingCreditCumulative: 0,
      incomeGrowthReturnCumulative: 0,
      contributionsAll: 0,
      contributionsAllCumulative: 0,
      withdrawalsAll: 0,
      withdrawalsAllCumulative: 0,
      closingBalance: 0,
      incomeGrowthFees: 0,
      expenses: 0,
      platformFees: 0,
      adviceFees: 0,
      otherFees: 0,
      fees: 0,
      employer: 0,
      salarySacrifice: 0,
      contributionsTax: 0,
      nonContributionContribution: 0,
    };
    return superProjection;
  },

  getSuperBalanceGraphData(superProjection, incomeExpense) {
    let areachart = {
      minXAxis: 0,
      maxXAxis: superProjection.length,
      minYAxis: 0,
      maxYAxis: 0,
      data: [],
    };
    for (let i = 0; i < superProjection.length; i++) {
      let openingBalance = superProjection[i].openingBalance;
      if (areachart.maxYAxis < openingBalance) {
        areachart.maxYAxis = openingBalance;
      }

      if (i == 0)
        this.addAreaChartCoordinate(
          areachart,
          i,
          openingBalance < 0 ? 0 : openingBalance,
          superProjection[i].incomeReturnCumulative,
          superProjection[i].year - 1,
          superProjection[i].growthReturnCumulative,
          incomeExpense[i]
        );

      let closingBalance = superProjection[i].closingBalance;
      if (areachart.maxYAxis < closingBalance) {
        areachart.maxYAxis = closingBalance;
      }

      this.addAreaChartCoordinate(
        areachart,
        i + 1,
        closingBalance < 0 ? 0 : closingBalance,
        superProjection[i].incomeReturnCumulative,
        superProjection[i].year,
        superProjection[i].growthReturnCumulative,
        incomeExpense[i]
      );
    }

    return areachart;
  },

  addAreaChartCoordinate(
    areachart,
    index,
    balance,
    incomeReturnCumulative,
    year,
    growthReturnCumulative,
    incomeExpense
  ) {
    areachart.data.push({
      id: index,
      value: {
        x: index,
        y: balance,
        title: [
          { value: "Year " + parseInt(index), class: "bold-text" },
          { value: "|" },
          {
            value: year,
            class: "bold-text",
          },

          { value: " | Age ", class: "bold-text" },
          {
            value: incomeExpense.age,
            class: "bold-text",
          },
        ],
        tooltipText: [
          {
            id: "Balance",
            value: CommonHelper.convertIntoCurrencyWithoutDecimal(balance),
          },
          {
            id: "Income",
            value: CommonHelper.convertIntoCurrencyWithoutDecimal(
              incomeReturnCumulative
            ),
          },
          {
            id: "Growth",
            value: CommonHelper.convertIntoCurrencyWithoutDecimal(
              growthReturnCumulative
            ),
          },
        ],
      },
    });
  },
  getSuperContributionWithdrawalGraphData(superProjection, incomeExpense) {
    let barchart = {
      minXAxis: 0,
      maxXAxis: superProjection.length,
      minYAxis: 0,
      maxYAxis: 0,
      data: [],
    };
    for (let i = 0; i < superProjection.length; i++) {
      let contributionsAll = parseFloat(superProjection[i].contributionsAll);
      let withdrawalsAll = parseFloat(superProjection[i].withdrawalsAll);

      if (barchart.maxYAxis < contributionsAll) {
        barchart.maxYAxis = contributionsAll;
      }
      if (barchart.minYAxis < -withdrawalsAll) {
        barchart.minYAxis = -withdrawalsAll;
      }
      barchart.data.push({
        id: i,
        title: `Year ${i + 1} | ${incomeExpense[i].year} | Age ${
          incomeExpense[i].age
        }`,
        value: [
          {
            id: "contributionsEOM_" + i,
            value: contributionsAll,
          },
          {
            id: "withdrawalsEOM_" + i,
            value: withdrawalsAll,
          },
        ],
        toolBarData: [
          {
            id: "Net Contributions",
            value: contributionsAll,
            hideKeyType: true,
            class: "bold-text",
          },
          {
            id: "Employer",
            value: superProjection[i].employer,
            hideKeyType: true,
            class: "left-margin",
          },
          {
            id: "Salary Sacrifice",
            value: superProjection[i].salarySacrifice,
            hideKeyType: true,
            class: "left-margin",
          },
          {
            id: "Contributions Tax",
            value: superProjection[i].contributionsTax,
            hideKeyType: true,
            class: "left-margin",
          },
          {
            id: "Non Concessional",
            value: superProjection[i].nonContributionContribution,
            hideKeyType: true,
            class: "left-margin",
          },
          {
            id: "Withdrawals",
            value: withdrawalsAll,
            hideKeyType: true,
            class: "bold-text",
          },
          {
            id: "Net",
            value: contributionsAll + withdrawalsAll,
            hideKeyType: true,
            class: "bold-text",
          },
        ],
      });
    }
    return barchart;
  },

  getincomeExpenseGraphData(incomeExpense) {
    let barchart = {
      minXAxis: 0,
      maxXAxis: incomeExpense.length,
      minYAxis: 0,
      maxYAxis: 0,
      data: [],
      lineData: [],
    };
    let totalExpense = 0;
    for (let i = 0; i < incomeExpense.length; i++) {
      let totalIncome = parseFloat(parseFloat(incomeExpense[i].totalIncome));
      totalExpense = parseFloat(-incomeExpense[i].totalExpense);

      if (barchart.maxYAxis < totalIncome) {
        barchart.maxYAxis = totalIncome;
      }
      if (barchart.maxYAxis < totalExpense) {
        barchart.maxYAxis = totalExpense;
      }

      barchart.data.push({
        id: i,
        title: `Year ${i + 1} | ${incomeExpense[i].year} | Age ${
          incomeExpense[i].age
        }`,
        value: [
          {
            id: "income" + i,
            value: totalIncome,
          },
        ],

        toolBarData: [
          {
            id: "Inflow",
            value: incomeExpense[i].inflow,
            hideKeyType: true,
            class: "bold-text",
          },
          {
            id: "Income",
            value: incomeExpense[i].employmentIncome,
            hideKeyType: true,
            class: "left-margin",
          },
          {
            id: "Age Pension",
            value: incomeExpense[i].agePension,
            hideKeyType: true,
            class: "left-margin",
          },
          {
            id: "Super Pension",
            value: incomeExpense[i].superPension,
            hideKeyType: true,
            class: "left-margin",
          },
          {
            id: "Other Income",
            value: incomeExpense[i].otherIncome,
            hideKeyType: true,
            class: "left-margin",
          },
          {
            id: "Outflow",
            value: incomeExpense[i].totalOutflow,
            hideKeyType: true,
            class: "bold-text",
          },
          {
            id: "Expenses",
            value: incomeExpense[i].expenses,
            hideKeyType: true,
            class: "left-margin",
          },
          {
            id: "Inv Contributions",
            value: incomeExpense[i].invContribution,
            hideKeyType: true,
            class: "left-margin",
          },
          {
            id: "Super Contributions",
            value: incomeExpense[i].superContribution,
            hideKeyType: true,
            class: "left-margin",
          },
          {
            id: "Taxes",
            value: incomeExpense[i].taxes,
            hideKeyType: true,
            class: "bold-text",
          },
          {
            id: "Net Cashflow",
            value: incomeExpense[i].netCashFlow,
            hideKeyType: true,
            class: "bold-text",
          },
        ],
      });
      barchart.lineData.push({
        id: "expense" + i,
        value: { x: i, y: totalExpense },
      });
    }
    if (barchart.lineData.length > 0)
      barchart.lineData.push({
        id: "expense" + incomeExpense.length,
        value: { x: incomeExpense.length, y: totalExpense },
      });
    return barchart;
  },

  getSuperReturnFeesGraphData(superProjection, incomeExpense) {
    let barchart = {
      minXAxis: 0,
      maxXAxis: superProjection.length,
      minYAxis: 0,
      maxYAxis: 0,
      data: [],
    };
    for (let i = 0; i < superProjection.length; i++) {
      let incomeAmount = parseFloat(superProjection[i].incomeReturn);
      let growthAmount = parseFloat(superProjection[i].growthReturn);
      let PositiveGrowthAmount = growthAmount > 0 ? growthAmount : 0;
      let feesAmount =
        parseFloat(superProjection[i].platformFees) +
        parseFloat(superProjection[i].adviceFees) +
        parseFloat(superProjection[i].otherFees);

      if (barchart.maxYAxis < incomeAmount + PositiveGrowthAmount) {
        barchart.maxYAxis = incomeAmount + PositiveGrowthAmount;
      }
      if (barchart.minYAxis < -growthAmount - feesAmount) {
        barchart.minYAxis = -growthAmount - feesAmount;
      }

      barchart.data.push({
        id: i,
        title: `Year ${i + 1} | ${incomeExpense[i].year} | Age ${
          incomeExpense[i].age
        }`,
        value: [
          {
            id: "Income" + i,
            value: incomeAmount,
          },
          {
            id: "Growth" + i,
            value: growthAmount,
          },
          {
            id: "Fees" + i,
            value: feesAmount,
          },
        ],
        toolBarData: [
          { id: "Income", value: incomeAmount },
          { id: "Growth", value: growthAmount },
          { id: "Fees", value: feesAmount },
          { id: "Net Return", value: incomeAmount + growthAmount + feesAmount },
          {
            id: "Franking Credit",
            value: superProjection[i].frankingCredit,
          },
        ],
      });
    }
    return barchart;
  },
};
